import poiIcon from '@atom/components/common/svgIcons/googlePlaces.svg';
import poiActiveIcon from '@atom/components/common/svgIcons/googlePlacesActive.svg';

import MapControl from '../../../mapControl/MapControl';

import classes from './layerControls.module.css';

interface Props {
  mapTypeId: string;
  setMapTypeId: (string) => any;
  toggleTraffic?: () => any;
  traffic?: boolean;
  togglePointsOfInterest: () => void;
  pointsOfInterest?: boolean;
}

const LayerControls = ({
  mapTypeId,
  setMapTypeId,
  traffic,
  toggleTraffic,
  pointsOfInterest,
  togglePointsOfInterest,
}: Props) => {
  return (
    <div className={classes.layerControlsContainer}>
      <div className={classes.iconContainer}>
        <MapControl
          icon="satellite"
          tooltip="Satellite"
          onClick={() => setMapTypeId('hybrid')}
          active={mapTypeId === 'hybrid'}
        />
      </div>
      <div className={classes.iconContainer}>
        <MapControl
          icon="map"
          tooltip="Map"
          onClick={() => setMapTypeId('roadmap')}
          active={mapTypeId === 'roadmap'}
        />
      </div>
      <div className={classes.iconContainer}>
        <MapControl
          icon="traffic"
          tooltip="Traffic"
          onClick={toggleTraffic}
          active={traffic}
        />
      </div>
      <div className={classes.iconContainer}>
        <MapControl
          icon={<img src={pointsOfInterest ? poiActiveIcon : poiIcon} />}
          tooltip="Google Places"
          onClick={togglePointsOfInterest}
          active={pointsOfInterest}
        />
      </div>
    </div>
  );
};

export default LayerControls;
